module.exports = __webpack_public_path__ + "img/icon-device-notebook.852600ea.svg";